<template>
    <b-navbar :fixed-top="top" :centered="centered" type="is-primary">
        <template #brand>
            <b-navbar-item>
                <p class="title">&#128118; Baby Log</p>
            </b-navbar-item>
        </template>
        <template #end>
            <b-navbar-item>
                <p class="has-text-white m-2">
                    Source Code in
                    <a class="has-text-white has-text-weight-bold" href="https://github.com/mvaldes14/babylog">Git</a>
                </p>
            </b-navbar-item>
        </template>
    </b-navbar>
</template>

<script>
export default {
    data() {
        return {
            top: true,
            centered: true,
        }
    }
}
</script>

<style>
</style>